import { Link } from "react-router-dom";
import images from "../assets/images/assets";

const Footer = () => {
  const instaUrl = "https://www.instagram.com/itsallaboutcards/?hl=en";

  return (
    <footer className="bg-prime-white centered-row justify-between text-prime-red p-4 items-center">
      <div className="container mx-auto md:px-4 ">
        <div className="top col md:flex-row md:justify-between gap-2 md:py-5">
          <Link to="/">
            <p className="logo font-semibold tracking-tight 2xl:text-lg">
              it&#39;s all about cards
            </p>
          </Link>

          <nav className="">
            <ul className="centered-row gap-5 md:gap-6 lg:gap-10 cursor-pointer 2xl:text-lg">
              <li>
                <Link to="/">Home</Link>
              </li>
              <li>
                <Link to="/collections">Collection</Link>
              </li>
              <li>
                <Link to="/story">Our story</Link>
              </li>
              <li>
                <Link to="/contact">Contact Us</Link>
              </li>
            </ul>
          </nav>

          <div className="icons centered-row gap-5 cursor-pointer">
            <img
              src={images.facebook}
              alt="facebook link"
              className="w-8 hover:-translate-y-2 transition2"
            />

            <Link to={instaUrl} target="_blank">
              <img
                src={images.insta}
                alt="instagram link"
                className="w-8 hover:-translate-y-2 transition2"
              />
            </Link>

            <img
              src={images.linkedin}
              alt="linkedin link"
              className="w-8 hover:-translate-y-2 transition2"
            />
          </div>
        </div>

        <hr className="my-2" />

        <div className="bottom md: ">
          <p className="mt-2 md:my-5 md:text-center">
            &copy; {new Date().getFullYear()}{" "}
            <span className="mx-1 montserra font-semibold">
              itsallaboutcards
            </span>{" "}
            All Rights Reserved.
          </p>
          <p className="mt-4">
            <ul className="grid grid-cols-2 gap-4 md:grid-cols-3 md:text-center">
              <li className="montserrat">Privact Policy</li>
              <li className="montserrat">Terms of Service</li>
              <li className="montserrat"> Cookie Settings </li>
            </ul>
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
